export default "__VITE_ASSET__0a064baf__"